import { render, staticRenderFns } from "./StepBox.vue?vue&type=template&id=48dc6584&scoped=true"
import script from "./StepBox.vue?vue&type=script&lang=js"
export * from "./StepBox.vue?vue&type=script&lang=js"
import style0 from "./StepBox.vue?vue&type=style&index=0&id=48dc6584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dc6584",
  null
  
)

export default component.exports